<template>
    <div class="Login-container">
        <div id="main" style="width: 560px;height:220px;"></div>
    </div>
</template>

<script>
    const echarts = require('echarts');
    export default {
        data() {
            return {
                list: [],
            }
        },
        watch: {
            list(n) {
                this.init()
            }
        },
        mounted() {
            this.getData()
        },
        methods: {
            getData() {
                this.list = [{
                        x: '3-10',
                        y1: 134,
                        y2: 12
                    },
                    {
                        x: '3-11',
                        y1: 143,
                        y2: 2
                    },
                    {
                        x: '3-12',
                        y1: 43,
                        y2: 32
                    },
                    {
                        x: '3-13',
                        y1: 220,
                        y2: 13
                    },
                    {
                        x: '3-14',
                        y1: 322,
                        y2: 56
                    },
                    {
                        x: '3-15',
                        y1: 120,
                        y2: 66
                    },
                    {
                        x: '3-16',
                        y1: 134,
                        y2: 12
                    },
                    {
                        x: '3-17',
                        y1: 212,
                        y2: 87
                    }
                ]
            },
            init() {
                // 基于准备好的dom，初始化echarts实例
                var myChart = echarts.init(document.getElementById('main'));

                let xAxisData = []
                let seriesData = []
                let seriesData2 = []

                this.list.forEach((i, k) => {
                    xAxisData.push(i.x || '')
                    seriesData.push(i.y1 || 0)
                    seriesData2.push(i.y2 || 0)
                })



                let seriesConfig = {
                    areaStyle: {
                        opacity: 0.8,
                        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                            offset: 0,
                            color: 'rgba(175, 57, 79,1)'
                        }, {
                            offset: 1,
                            color: 'rgba(68, 36, 52,0.5)'
                        }])
                    },
                    lineStyle: {
                        color: '#f94762',
                        width: 3
                    },
                    // 圆弧
                    smooth: true,
                    // 拐点
                    symbol: 'circle',
                    symbolSize: 9,
                    itemStyle: {
                        borderWidth: 1,
                        borderColor: '#ff475d',
                        color: '#ffffff'
                    },
                    // 文本标签
                    label: {
                        show: true,
                        position: 'top',
                        align: 'left',
                        fontSize: 12,
                        color: '#ffffff'
                    },
                }



                // 指定图表的配置项和数据
                let option = {
                    title: {
                        subtext: '单位：天',
                        subtextStyle: {
                            //文字颜色
                            color: '#74a0bf',
                            //字体大小
                            fontSize: 12
                        }
                    },
                    tooltip: {
                        show: true,
                        trigger: 'axis',
                        axisPointer: {
                            type: 'cross',
                            label: {
                                backgroundColor: '#01b3e4'
                            }
                        }
                    },
                    xAxis: {
                        type: 'category',
                        boundaryGap: true,
                        data: xAxisData,
                        // 刻度
                        axisTick: {
                            show: false
                        },
                        axisLine: {
                            lineStyle: {
                                type: 'solid',
                                color: '#74a0bf', //左边线的颜色
                                width: '1' //坐标线的宽度
                            }
                        },
                        axisLabel: {
                            textStyle: {
                                // 坐标值得具体的颜色
                                color: '#74a0bf',
                                fontSize: 12
                            }
                        }
                    },
                    yAxis: {
                        type: 'value',
                        // 是否是脱离 0 值比例，true：自适应
                        scale: false,
                        minInterval: 20, //分割刻度
                        splitNumber: 20,
                        max: function(value) { //取最大值向上取整为最大刻度
                            return Math.ceil(value.max + 20)
                        },
                        axisLine: {
                            lineStyle: {
                                type: 'solid',
                                color: '#74a0bf',
                                width: '1'
                            }
                        },
                        axisLabel: {
                            textStyle: {
                                color: '#74a0bf',
                                fontSize: 12
                            }
                        },
                        splitLine: {
                            show: true, //X网格线
                            lineStyle: { //x网格线
                                color: '#002d37'
                            }
                        }
                    },

                    series: [{
                            ...seriesConfig,
                            data: seriesData,
                            type: 'line',
                        },
                        {
                            ...seriesConfig,
                            data: seriesData2,
                            type: 'line',
                        },
                    ],
                    showAllSymbol: 0
                };

                // 使用刚指定的配置项和数据显示图表。
                myChart.setOption(option);
            }
        }
    }
</script>

<style lang="less">
    #main {
        margin: 200px 50px;
        background-color: #051c2c;
        color: #74a0bf;
    }
</style>
